// extracted by mini-css-extract-plugin
export default {"carrierCapacity":"CarrierCapacity_carrierCapacity__pArDV","carrierCapacityShipmentMatches":"CarrierCapacity_carrierCapacityShipmentMatches__wOzTB"};